import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { reduxFirestore, getFirestore, firestoreReducer } from 'redux-firestore'
// import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import app from '../modules/app.module'
import auction from '../modules/auction.module'
import firebase from './firebase'
import user from '../modules/user.module'

const analytics = () => next => action => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: action.type,
    payload: action.payload,
  })

  return next(action)
}

// Redux store constants
const configureStore = (initialState = {}) => {
  const reducers = combineReducers({
    firestore: firestoreReducer,
    auction,
    app,
    user,
  })

  // Middleware and store enhancers
  const middlewares = [
    thunk.withExtraArgument({ getFirestore }),
    process.env.NODE_ENV !== 'production' && logger,
    analytics,
  ].filter(Boolean)
  const enhancer = compose(
    applyMiddleware(...middlewares),
    reduxFirestore(firebase),
  )

  const store = createStore(reducers, initialState, enhancer)
  // const store = createStore(reducers, initialState, composeWithDevTools(enhancer));

  return store
}

const store = configureStore()

export default store
